function loadScript(url, func) {
    let source = document.createElement('script');
    source.language = 'javascript';
    source.type = 'text/javascript';
    source.charset = 'UTF-8';
    source.onload = source.onreadystatechange = function() {
        if (
            !source.readyState ||
            'loaded' == source.readyState ||
            'complete' == source.readyState
        ) {
            func();
        }
    };
    source.src = url;
    document.getElementsByTagName('head')[0].appendChild(source);
}

export { loadScript };
